import type { SurveyPage } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { getNextSequentialPageIndex } from './skipEmptyPagesForward';
import { shouldIncludePageInPath } from '../visibility';

export function getNextVisiblePageIndex(
  pages: SurveyPage[],
  currentPageIndex: number,
  context: LogicContext
): number {
  let pageIndex = getNextSequentialPageIndex(pages, currentPageIndex);

  while (pageIndex < pages.length) {
    const page = pages[pageIndex];
    const questions = page?.questions ?? [];

    if (shouldIncludePageInPath(questions, context)) {
      return pageIndex;
    }

    pageIndex = getNextSequentialPageIndex(pages, pageIndex);
  }

  return pageIndex;
}
